import { Button } from 'reactstrap'
import PropTypes from 'prop-types'
import TimeUtil from 'utils/time-util'
import CmsStoryGroupStatusBadge from 'domains/cms-story-group/status-badge/cms-story-group-status-badge'

const propTypes = {
  cmsStoryGroup : PropTypes.object,
  onRowClick    : PropTypes.func
}

const defaultProps = {
  cmsStoryGroup : {},
  onRowClick    : () => {}
}

const CmsStoryGroupTableRow = ({
  cmsStoryGroup,
  onRowClick
}) => (
  <tr>
    <td>{ cmsStoryGroup?.id }</td>
    <td>{ cmsStoryGroup?.title }</td>
    <td>
      <img
        style={{ width: '5rem' }}
        src={ cmsStoryGroup?.thumbnail_cms_image?.url }
        alt={ cmsStoryGroup?.thumbnail_cms_image?.file_name }
      />
    </td>
    <td>
      <CmsStoryGroupStatusBadge is_active={ cmsStoryGroup.is_active } />
    </td>
    <td>
      { TimeUtil.format(cmsStoryGroup?.starts_at, 'DD MMM YY HH:mm') }
    </td>
    <td>
      { TimeUtil.format(cmsStoryGroup?.expires_at, 'DD MMM YY HH:mm') }
    </td>
    <td className="d-flex flex-column bd-highlight mb-3">
      <Button
        size='sm'
        color='info'
        className= 'align-self-center'
        onClick={ () => onRowClick(cmsStoryGroup.id) }
      >
        { 'Detail' }
      </Button>
    </td>
  </tr>
)

CmsStoryGroupTableRow.propTypes    = propTypes
CmsStoryGroupTableRow.defaultProps = defaultProps

export default CmsStoryGroupTableRow